
import {
  defineComponent,
  defineAsyncComponent,
  ComputedRef,
  ref,
  Ref,
  computed,
  onMounted,
  reactive,
  watch,
  toRefs,
  onUnmounted,
} from 'vue'
import {useStore} from 'vuex'
const LinksChartCard = defineAsyncComponent({
  loader: () => import('./component/LinksChartCard/index.vue'),
})
import {message, Form} from 'ant-design-vue'
import {Props, validateInfos} from 'ant-design-vue/lib/form/useForm'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
const useForm = Form.useForm
import {
  UserInfoType,
  orderType,
  productSearchDtoType,
  PaginationConfig,
  PaginationConfig1,
  getTableList,
  AreaParams,
  serchObjType,
  noticeInfoType,
} from './data'
import productInfo from './component/productInfo/index.vue'
import {StateType as UserOrderDataListType} from './store'
import {StateType as CountryStateType} from '@/store/country'
import dayjs, {Dayjs} from 'dayjs'
import {arealistFn} from '@/utils/array'
import {StateType as AreaStateType} from '@/store/area'
import router from '@/config/routes'
import {twoFloat} from '@/utils/number'

interface HoneSetupData {
  arealist: Ref<any[]>
  columns: any
  visible: Ref<boolean>
  typeStr: Ref<string>
  toShipQty: Ref<number>
  pickedQty: Ref<number>
  abnormalQty: Ref<number>
  modelRef: orderType
  // countrylist: ComputedRef<any[]>
  countrylistSet: Ref<any>
  timelinessList: any
  setWidth: any
  validateInfos: ComputedRef<validateInfos>
  loading: Ref<boolean>
  list: Ref<any[]>
  pagination: ComputedRef<PaginationConfig1>
  serchRef: serchObjType
  isTime: Ref<boolean>
  tipsType: Ref<string>
  newArealist: Ref<any[]>
  noticeData: any
  filterDestination: any
  filterDestinationEchart: any
  handleSearch: (value: any) => void
  handleRest: (value: any) => void
  handleSelectDes: (e: MouseEvent) => void
  handleTableChange: (pagination: PaginationConfig1) => void
  changeTxt: (val: string | number, type: string) => string
  desTxt: (val: string | number, type: string) => void
  productDescription: (value: any) => void
  productService: (value: any) => void
  selectCity: (e: MouseEvent) => void
  twoNumber: (val: number) => number
  handleDeliveryType: (e: MouseEvent) => void;
}

// 时效日期范围
const TIMELINESS_DAY_RANGE_BEGIN = 8
const TIMELINESS_DAY_RANGE_END = 16

export default defineComponent({
  name: 'Home',
  components: {
    LinksChartCard,
    productInfo,
  },
  setup(props): HoneSetupData {
    const arealist = ref<any[]>([])
    const newArealist = ref<any[]>([])
    const visible = ref<boolean>(true)
    const typeStr = ref<string>('')
    const toShipQty = ref<number>(0)
    const pickedQty = ref<number>(0)
    const abnormalQty = ref<number>(0)
    // const countrylist = ref<any>([])
    const countrylistSet = ref<any>([])
    const isTime = ref<boolean>(false)
    const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
    const pageNum = reactive<PaginationParam>({pageNo: 1, pageSize: 10})
    const loading = ref<boolean>(false)
    const timelinessList = ref<any>([])
    const setWidth = ref<any>([])
    const tipsType = ref<string>('')
    const list = ref<any[]>([])
    const noticeData = ref<any>([])
    const searchflag = ref<boolean>(false)
    const store = useStore<{
      Home: UserOrderDataListType
      area: AreaStateType
      country: CountryStateType
    }>()
    const columns = [
      {
        title: '序号',
        dataIndex: 'number',
        customRender: ({text, index}: {text: any; index: number}) =>
          (pagination.value.pageNo - 1) * pagination.value.pageSize + index + 1,
      },
      {title: '目的国', dataIndex: 'destination'},
      {title: '产品类别', dataIndex: 'productCategory'},
      {title: '商品属性', dataIndex: 'battery'},
      {title: '时效(自然日)', dataIndex: 'durationStart'},
      {title: '揽收方式', dataIndex: 'pickupWay'},
      {title: '交货城市', dataIndex: 'city'},
      {title: '包裹重量(kg)', dataIndex: 'parcelWeightBegin'},
      {title: '运费(元/kg)', dataIndex: 'freight'},
      {title: '操作费(元/件)', dataIndex: 'operationFee'},
      {title: '币种', dataIndex: 'currency'},
      {title: '物流费用试算', dataIndex: 'freightTrial'},
      {title: '产品服务说明', dataIndex: 'productDescription'},
    ]

    const handleSearch = async (value: any) => {
      if (value == 'orderInfo') {
        const fieldsValue = await validate<orderType>()
        const st =
          (fieldsValue.time &&
            (fieldsValue.time as []).length != 0 &&
            dayjs(fieldsValue.time[0]).format('YYYY-MM-DD')) ||
          ''
        const et =
          (fieldsValue.time &&
            (fieldsValue.time as []).length != 0 &&
            dayjs(fieldsValue.time[1]).format('YYYY-MM-DD')) ||
          ''
        modelRef.destination == '全部' ? modelRef.destination = '' : modelRef.destination
        modelRef.startTime = st
        modelRef.endTime = et
        // console.log('modelRef',modelRef)
        getTimelinessView(modelRef)
      } else {
        serchRef.parcelWeightBegin == '' || serchRef.parcelWeightBegin == null ? serchRef.parcelWeightBegin = 0 : serchRef.parcelWeightBegin
        serchRef.parcelWeightEnd == '' || serchRef.parcelWeightEnd == null ? serchRef.parcelWeightEnd = 9999 : serchRef.parcelWeightEnd
        const data = JSON.parse(JSON.stringify(serchRef))
        searchflag.value = true
        pageNum.pageNo = 1
        const params = {
          ...data,
          ...pageNum,
        }
        console.log('serchRef', params)
        getSpecialProductList(params)
      }
    }
    //重置
    const handleRest = (value: any) => {
      if (value == 'orderInfo') {
        resetFields()
        getTimelinessView({userCode: userMsg.userCode})
      } else {
        searchflag.value = false
        serchRef.destination = null
        serchRef.pickupWay = null
        serchRef.cityName = null
        serchRef.battery = 0
        ;(serchRef.parcelWeightBegin = 0.2), (serchRef.parcelWeightEnd = 0.3)
        const params = {
          ...serchRef,
          ...pageNum,
        }
        getSpecialProductList(params)
      }
    }

    //查询单量接口
    const getOrderNumber = async (params: UserInfoType) => {
      // try {
      //   const res: boolean = await store.dispatch('Home/getOrderNumberData', params)
      //   if (res === true) {
      //     toShipQty.value = store.state.Home.userOrderInfo.toShipQty
      //     pickedQty.value = store.state.Home.userOrderInfo.pickedQty
      //     abnormalQty.value = store.state.Home.userOrderInfo.abnormalQty
      //   }
      // } catch (error) {
      //   console.log(error)
      // }
    }

    //查询时效展示接口
    const getTimelinessView = async (params: orderType) => {
      try {
        const res: boolean = await store.dispatch('Home/getTimelinessData', params)
        if (res === true) {
          if(store.state.Home.timelinessList != null){
            console.log('store.state.Home.timelinessList',store.state.Home.timelinessList)
            let n = store.state.Home.timelinessList.map(destVals => {
              if (destVals.length === 0) {
                return []
              }
              const sample = destVals[0]

              const destValMaps = {}
              destVals.forEach(vals => {
                destValMaps[`day_${vals.deliveredCycle}`] = vals
                countrylistSet.value.map((tag:any) => {
                  if(vals.destination == tag.code){
                    vals.destination = tag.name
                  }
                })
              })

              const ret: Object[] = []
              for (let i = TIMELINESS_DAY_RANGE_BEGIN; i <= TIMELINESS_DAY_RANGE_END; i++) {
                if (typeof destValMaps[`day_${i}`] !== 'undefined') {
                  ret.push(destValMaps[`day_${i}`])
                } else {
                  ret.push({...sample, orderNum: 0, deliveredCycle: i})
                }
              }

              return ret

            })

            const s = reactive<any>([])
            n.map((item:any) => {
              item.map((tag:any) => {
                if(tag.orderNum > 0){
                  s.push(item)
                }
              })
            })

            timelinessList.value = Array.from(new Set(s))
            if (timelinessList.value && timelinessList.value.length > 0) {
              setWidth.value = 'width:' + timelinessList.value.length * 360 + 'px'
              isTime.value = true
            }
          }else{
            timelinessList.value = []
          }

        }
      } catch (error) {
        console.log(error)
      }
    }

    const modelRef = reactive<orderType>({
      destination: '全部',
      time: [dayjs().subtract(2, 'month').endOf('day'), dayjs().add(0, 'month').endOf('day')],
      endTime: '',
      startTime: '',
      userCode: userMsg.userCode,
    })

    const rulesRef = reactive({
      destination: [],
      time: [],
      endTime: [],
      startTime: [],
      userCode: [],
    })

    const serchRef = reactive<serchObjType>({
      pickupWay: null,
      cityName: null,
      battery: 0,
      parcelWeightBegin: 0.2,
      parcelWeightEnd: 0.3,
    })

    const {resetFields, validate, validateInfos} = useForm(modelRef, rulesRef)
    const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
    // const countrylist = computed<any[]>(() => store.state.destination.destinationList)
    // const countryName = async (param: {}) => {
    //   try {
    //     const res: boolean = await store.dispatch('destination/getDestinationFn', param)
    //     if (res === true) {
    //       const res = new Map()
    //       let hasObj = {}
    //       const person = countrylist.value.reduce((cur, next) => {
    //         hasObj[next.code] ? '' : (hasObj[next.code] = true && cur.push(next))
    //         return cur
    //       }, [])
    //       console.log('person', person)
    //     }
    //   } catch (error) {
    //     message.warning('error=>' + error)
    //   }
    // }
    //选择目的国后国家是英文
    const handleSelectDes = (e: MouseEvent) => {
      modelRef.destination = modelRef.destination
    }

    //获取地址
    const areaList = async (params: AreaParams) => {
      try {
        const res: boolean = await store.dispatch('area/getAreaFn', params)
        if (res) {
          arealist.value = arealistFn(store.state.area.arealist, 1)
        }
      } catch (error) {
        message.warning('获取地区信息失败!')
      }
    }

    //分页
    const handleTableChange = (pagination: PaginationConfig1) => {
      pageNum.pageNo = pagination.current
      pageNum.pageSize = pagination.pageSize
      serchRef.parcelWeightBegin == '' || serchRef.parcelWeightBegin == null ? serchRef.parcelWeightBegin = 0 : serchRef.parcelWeightBegin
      serchRef.parcelWeightEnd == '' || serchRef.parcelWeightEnd == null ? serchRef.parcelWeightEnd = 9999 : serchRef.parcelWeightEnd
      const params = searchflag.value ? {...serchRef, ...pageNum} : {...pageNum}
      getSpecialProductList(params)
    }

    //列表
    // const list = computed<productSearchDtoType[]>(() => store.state.Home.tableData.contlist)
    const pagination = computed<PaginationConfig1>(() => store.state.Home.tableData.pagination)
    const getSpecialProductList = async (params: getTableList) => {
      loading.value = true
      try {
        const res: boolean = await store.dispatch('Home/getPageListFn', params)
        if (res === true) {
          // console.log('store.state.country.countryCn', countrylistSet, store.state.Home.tableData.contlist)
          countrylistSet.value.map((item: any) => {
            //根据国家匹配返回的目的国
            store.state.Home.tableData.contlist.map((tag: any) => {
              if (item.code == tag.destination) {
                tag.destination = item.name
              }
            })
          })
          list.value = store.state.Home.tableData.contlist
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
      loading.value = false
    }

    //枚举转换
    const changeTxt = (val: string | number, type: string) => {
      const objbat = {
        true: '带电',
        false: '普货',
      }
      const objway = {
        '1': '上门揽收',
        '2': '自送/邮寄',
      }
      const cityList = localStorage.getItem('areaList') && JSON.parse(String(localStorage.getItem('areaList')))
      switch (type) {
        case 'battery':
          return objbat[val] || val
        case 'pickupWay':
          return objway[val] || val
        case 'city':
          return cityList[val] || val
      }
    }

    //国家枚举转换
    const desTxt = (val: string | number, type: string) => {
      const at = countrylistSet.value.filter((item: any) => {
        if (item.code == val) {
          return item.name
        }
      })
      return JSON.parse(JSON.stringify(at))
    }

    // 产品说明
    const productDescription = (value: any) => {
      router.push({
        path: '/home/productInfo',
        query: {
          value: value.bizProductCode,
          destinationName: value.destination,
        },
      })
    }

    const productService = (value: any) => {
      localStorage.setItem('initconfig',JSON.stringify(value))
      router.push({
        path: '/home/freightcalculation',
      })
    }

    //提示查询接口
    const homePageNotice = async (params: noticeInfoType) => {
      try {
        const res: boolean = await store.dispatch('Home/getNoticeInfoFn', params)
        if (res === true) {
          noticeData.value = store.state.Home.notice
          console.log('store.state.Home.notice', store.state.Home.notice)
        }
      } catch (error) {
        console.log(error)
      }
    }

    const selectCity = async (e: MouseEvent) => {
      console.log(e)
      serchRef.cityName = e[1]
    }

    const filterDestination = (input: string, option: any) => {
      return option.key.indexOf(input) >= 0
    }

    const filterDestinationEchart = (input: string, option: any) => {
      return option.key.indexOf(input) >= 0
    }

    //保留两位小数
    const twoNumber = (val: string | number) => {
      return twoFloat(val)
    }

    const handleDeliveryType = (e: MouseEvent) => {
        newArealist.value = []
        serchRef.cityName = null
        console.log(serchRef.pickupWay)
        if(serchRef.pickupWay == 1){
            newArealist.value = localStorage.getItem('pickupScopeList') && JSON.parse(String(localStorage.getItem('pickupScopeList')))
        }else{
            const newArea = localStorage.getItem('stationAreaList') && JSON.parse(String(localStorage.getItem('stationAreaList')))
            const arrList = [] as any
            newArea.map((item:any) => {
                item.children.map((tag:any) => {
                    delete tag.children
                    tag.id = tag.value
                    tag.city = tag.label
                    arrList.push(tag)
                })
            })
            newArealist.value = arrList
            console.log('arrList',arrList)
        }
    }

    onMounted(() => {
      // newArealist.value = localStorage.getItem('pickupScopeList') && JSON.parse(String(localStorage.getItem('pickupScopeList')))
      getOrderNumber({userCode: userMsg.userCode})
      getTimelinessView({userCode: userMsg.userCode})
      homePageNotice({userCode: userMsg.userCode})
      countrylistSet.value = JSON.parse(String(localStorage.getItem('person')))
      const params = {
        ...serchRef,
        ...pageNum,
      }
      getSpecialProductList(params)
      // countryName({})
      areaList({countryCode: '156'})
    })

    return {
      handleSearch,
      handleRest,
      columns,
      visible,
      typeStr,
      toShipQty,
      pickedQty,
      abnormalQty,
      modelRef,
      validateInfos: validateInfosNew,
      handleSelectDes,
      countrylistSet,
      timelinessList,
      handleTableChange,
      loading,
      list,
      pagination,
      arealist,
      serchRef,
      changeTxt,
      productDescription,
      setWidth,
      isTime,
      tipsType,
      desTxt,
      selectCity,
      newArealist,
      noticeData,
      filterDestination,
      filterDestinationEchart,
      twoNumber,
      productService,
      handleDeliveryType
    }
  },
})
